import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function FamilyCaregiverSection() {
  const benefits = [{
    label: 'Mandatory Background Checks',
    detail: 'We run thorough, mandatory background checks so your family caregiver is fully cleared and compliant'
  }, {
    label: 'Professional Training',
    detail: 'CPR, First Aid, CNA training — all handled on-site by our team'
  }, {
    label: 'Certification',
    detail: 'We certify your family member as a licensed, professional caregiver'
  }, {
    label: 'Full Approval & Compliance',
    detail: 'All paperwork, approvals, and ongoing compliance managed for you'
  }];
  return <section className="py-24 px-4 bg-neutral-light overflow-hidden" data-id="element-40">
      <div className="max-w-7xl mx-auto" data-id="element-41">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-42">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex-1" data-id="element-43">
            <h2 className="text-sm font-bold text-accent tracking-widest uppercase mb-2" data-id="element-44">
              Our Main Service
            </h2>
            <h3 className="text-3xl md:text-4xl font-heading font-bold text-neutral-dark mb-6" data-id="element-45">
              Hire Your Own Family Member as a Caregiver
            </h3>
            <p className="text-lg text-neutral-medium mb-4 leading-relaxed" data-id="element-46">
              A daughter caring for her mother. A nephew supporting his elderly
              uncle.{' '}
              <strong className="text-primary" data-id="element-47">
                Your family already has the love — we provide the credentials.
              </strong>
            </p>
            <p className="text-lg text-neutral-medium mb-8 leading-relaxed" data-id="element-48">
              Instead of sending strangers into your home, Ambient Solutions
              helps you hire your own family member as a professional caregiver.
              We handle everything to make it official:
            </p>

            <div className="space-y-5 mb-10" data-id="element-49">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-50">
                  <CheckCircle2Icon className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" data-id="element-51" />
                  <div data-id="element-52">
                    <span className="text-neutral-dark font-bold block" data-id="element-53">
                      {benefit.label}
                    </span>
                    <span className="text-neutral-medium text-sm" data-id="element-54">
                      {benefit.detail}
                    </span>
                  </div>
                </div>)}
            </div>

            <div className="bg-accent-light border-l-4 border-accent p-4 mb-10 rounded-r-lg" data-id="element-55">
              <p className="text-neutral-dark font-medium italic" data-id="element-56">
                If your family member cannot provide care, we can connect you
                with qualified caregivers.
              </p>
            </div>

            <a href="#contact" className="inline-block bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-lg font-semibold transition-all shadow-md hover:shadow-lg" data-id="element-57">
              Start Your Family Caregiver Journey
            </a>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 relative" data-id="element-58">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-59">
              <img src="https://cdn.magicpatterns.com/uploads/7XY24mh8db2dqQeyGd7gzG/image.png" alt="Caregiver assisting an elderly woman at a dining table" className="w-full h-auto object-cover" data-id="element-60" />
            </div>

            {/* Decorative Element */}
            <div className="absolute -bottom-6 -left-6 bg-accent-light p-6 rounded-2xl shadow-lg border border-white max-w-[200px] hidden md:block" data-id="element-61">
              <div className="flex items-center gap-2 mb-2" data-id="element-62">
                {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-accent fill-current" viewBox="0 0 20 20" data-id="element-63">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-64" />
                  </svg>)}
              </div>
              <p className="text-sm font-bold text-neutral-dark" data-id="element-65">
                "They made it so easy to care for my mom."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}